import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Container, Paper, Typography, Alert, Box } from '@mui/material';
import { Shield } from '@mui/icons-material';
import PageLayout from '../PageLayout';

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h6">Loading...</Typography>
        </Paper>
      </Container>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has admin role
  const isAdmin = user.role && (
    typeof user.role === 'object' 
      ? user.role.name === 'ADMIN' 
      : user.role === 'ADMIN'
  );

  // Show access denied if not admin
  if (!isAdmin) {
    return (
      <PageLayout>
        <Container maxWidth="sm" sx={{ mt: 8 }}>
          <Paper sx={{ p: 4 }}>
            <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
              <Shield sx={{ fontSize: 64, color: 'error.main' }} />
              <Typography variant="h4" component="h1" textAlign="center">
                Access Denied
              </Typography>
              <Alert severity="error" sx={{ width: '100%' }}>
                You don't have permission to access this admin area. Please contact your administrator if you believe this is an error.
              </Alert>
              <Typography variant="body1" color="text.secondary" textAlign="center">
                Current role: {typeof user.role === 'object' ? user.role.name : user.role || 'None'}
              </Typography>
            </Box>
          </Paper>
        </Container>
      </PageLayout>
    );
  }

  // Render admin content if user is admin
  return children;
};

export default AdminRoute;